// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noOp = (arg1: any) => {};
